var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddClassPopupPics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 238.881,
    height: 195.2,
    viewBox: "0 0 238.881 195.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.686,
    y1: 0.091,
    x2: -1.409,
    y2: 2.41,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#17161f",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#343247",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.564,
    y1: -0.253,
    x2: 0.517,
    y2: 0.298,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.769
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.599,
    y1: 4.112,
    x2: 0.416,
    y2: -2.554,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2.268,
    y1: 0.499,
    x2: -7.539,
    y2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#292838",
    stopOpacity: 0.659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5.408,
    y1: 0.499,
    x2: -11.239,
    y2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#67ddf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5cb3ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#538ea9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4c718b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#465a73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#424a63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#404059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.472,
    y1: 0.08,
    x2: 0.639,
    y2: 2.614,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.472,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.477,
    y1: 0.08,
    x2: 0.643,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.473,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.472,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.477,
    y1: 0.08,
    x2: 0.643,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.473,
    y1: 0.08,
    x2: 0.639,
    y2: 2.615,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1.255,
    y1: 0.72,
    x2: -0.438,
    y2: 0.295,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#edcbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 0.502,
    x2: 1,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.001,
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.196,
    y1: 0.676,
    x2: -1.453,
    y2: 2.686,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.846,
    y1: -0.323,
    x2: 0.242,
    y2: 0.981,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1.265,
    y1: 0.585,
    x2: -0.551,
    y2: 0.349,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2.509,
    y1: -0.84,
    x2: -1.815,
    y2: 1.582,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.974,
    y1: -1.234,
    x2: -0.513,
    y2: 1.608,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.477,
    y1: 0.275,
    x2: 1.968,
    y2: 0.795,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.309,
    y1: -0.199,
    x2: 1.045,
    y2: 2.495,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.506,
    y1: -0.783,
    x2: 0.488,
    y2: 2.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -0.286,
    y1: -0.433,
    x2: 1.588,
    y2: 1.675,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48343",
    "data-name": "Group 48343",
    transform: "translate(-0.001 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94666",
    "data-name": "Path 94666",
    d: "M51.873,41.7c-14.115,7.54-28.658,15.436-38.5,28.063A65.22,65.22,0,0,0,1.459,95.8c-3.551,16.05-.922,34.657,11.293,45.7a47.484,47.484,0,0,0,14.811,8.674,79.451,79.451,0,0,0,34.955,5.182c9.766-.762,19.516-3.335,29.233-2.109,11.852,1.491,22.2,8.422,33.242,12.987a86.791,86.791,0,0,0,43.39,5.918,28.993,28.993,0,0,0,10.74-3c3.878-2.168,6.752-5.709,9.809-8.946a85.581,85.581,0,0,1,24.018-17.881c4.718-2.361,9.717-4.319,13.814-7.641,10.79-8.73,12.637-24.352,12.009-38.2s-3.75-29.145-14.837-37.557c-2.475-1.877-5.261-3.332-7.661-5.31-8-6.6-10.4-17.643-15.524-26.67C189.256,6.75,163.607-2.088,140.514.41,107.422,3.99,80.321,26.508,51.873,41.7Z",
    transform: "translate(0 0)",
    fill: "#68e1fd",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94667",
    "data-name": "Path 94667",
    d: "M606.27,250.567c-.3,2.779-3.73,7.445-8.475,12.689-7.775,8.579-19.071,18.7-25.865,24.594h0c-3.505,3.044-5.81,4.963-5.81,4.963V240s8.226-10.535,14.2-11.211,18.038,6.314,18.038,6.314S607.277,240.9,606.27,250.567Z",
    transform: "translate(-381.023 -153.953)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94668",
    "data-name": "Path 94668",
    d: "M608.139,291.578c-7.775,8.579-19.071,18.7-25.865,24.594a6.093,6.093,0,0,1-.654-2.9c-.18-4.966-.137-9.939-.091-14.909.042-4.826.085-9.648.389-14.464.288-4.486.837-9.073,2.89-13.078a5.014,5.014,0,0,1,1.128,1.465c2.586,4.443,4.221,9.344,5.856,14.21q1.213,3.6,2.426,7.222A17.326,17.326,0,0,0,599,289.842c1.242-1.376,2.351-2.864,3.492-4.322.8-1.02,2.354-3.924,3.6-2.831C608.1,284.444,608.266,288.463,608.139,291.578Z",
    transform: "translate(-391.366 -182.276)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24248",
    "data-name": "Rectangle 24248",
    width: 133.918,
    height: 155.098,
    transform: "translate(57.218 16.503)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24249",
    "data-name": "Rectangle 24249",
    width: 133.918,
    height: 155.098,
    transform: "translate(57.218 16.503)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94669",
    "data-name": "Path 94669",
    d: "M290.514,57.977,175,68.332c.52,0,0-14.386,0-17.852H296.791V51.7A6.281,6.281,0,0,1,290.514,57.977Z",
    transform: "translate(-117.782 -33.977)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94714",
    "data-name": "Path 94714",
    d: "M0,0H133.918V155.1H0Z",
    transform: "translate(57.218 34.355)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24251",
    "data-name": "Rectangle 24251",
    width: 19.039,
    height: 155.098,
    transform: "translate(57.218 34.355)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24252",
    "data-name": "Rectangle 24252",
    width: 23.132,
    height: 23.132,
    transform: "translate(64.693 63.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24253",
    "data-name": "Rectangle 24253",
    width: 23.132,
    height: 23.132,
    transform: "translate(89.11 63.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24254",
    "data-name": "Rectangle 24254",
    width: 23.132,
    height: 23.132,
    transform: "translate(113.53 63.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24255",
    "data-name": "Rectangle 24255",
    width: 23.132,
    height: 23.132,
    transform: "translate(137.947 63.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24256",
    "data-name": "Rectangle 24256",
    width: 23.132,
    height: 23.132,
    transform: "translate(64.693 87.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24257",
    "data-name": "Rectangle 24257",
    width: 23.132,
    height: 23.132,
    transform: "translate(89.11 87.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24258",
    "data-name": "Rectangle 24258",
    width: 23.132,
    height: 23.132,
    transform: "translate(113.53 87.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24259",
    "data-name": "Rectangle 24259",
    width: 23.132,
    height: 23.132,
    transform: "translate(137.947 87.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24260",
    "data-name": "Rectangle 24260",
    width: 23.132,
    height: 23.132,
    transform: "translate(64.693 111.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24261",
    "data-name": "Rectangle 24261",
    width: 23.132,
    height: 23.132,
    transform: "translate(89.11 111.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24262",
    "data-name": "Rectangle 24262",
    width: 23.132,
    height: 23.132,
    transform: "translate(113.53 111.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24263",
    "data-name": "Rectangle 24263",
    width: 23.132,
    height: 23.132,
    transform: "translate(137.947 111.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24264",
    "data-name": "Rectangle 24264",
    width: 23.132,
    height: 23.132,
    transform: "translate(64.693 135.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24265",
    "data-name": "Rectangle 24265",
    width: 23.132,
    height: 23.132,
    transform: "translate(89.11 135.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24266",
    "data-name": "Rectangle 24266",
    width: 23.132,
    height: 23.132,
    transform: "translate(113.53 135.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24267",
    "data-name": "Rectangle 24267",
    width: 23.132,
    height: 23.132,
    transform: "translate(137.947 135.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24268",
    "data-name": "Rectangle 24268",
    width: 23.132,
    height: 23.132,
    transform: "translate(64.693 159.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24269",
    "data-name": "Rectangle 24269",
    width: 23.132,
    height: 23.132,
    transform: "translate(89.11 159.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24270",
    "data-name": "Rectangle 24270",
    width: 23.132,
    height: 23.132,
    transform: "translate(113.53 159.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24271",
    "data-name": "Rectangle 24271",
    width: 23.132,
    height: 23.132,
    transform: "translate(161.955 63.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24272",
    "data-name": "Rectangle 24272",
    width: 23.132,
    height: 23.132,
    transform: "translate(161.955 39.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24273",
    "data-name": "Rectangle 24273",
    width: 23.132,
    height: 23.132,
    transform: "translate(137.947 39.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24274",
    "data-name": "Rectangle 24274",
    width: 23.132,
    height: 23.132,
    transform: "translate(161.955 87.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24275",
    "data-name": "Rectangle 24275",
    width: 23.132,
    height: 23.132,
    transform: "translate(161.955 111.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24276",
    "data-name": "Rectangle 24276",
    width: 23.132,
    height: 23.132,
    transform: "translate(161.955 135.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94670",
    "data-name": "Path 94670",
    d: "M206.73,28.776V41.318c0,.677.86,1.226,1.916,1.226h0c1.059,0,1.916-.549,1.916-1.226V28.776c0-.677-.857-1.226-1.916-1.226h0C207.59,27.55,206.73,28.1,206.73,28.776Z",
    transform: "translate(-139.137 -18.544)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94671",
    "data-name": "Path 94671",
    d: "M262.75,28.776V41.318c0,.677.857,1.226,1.916,1.226h0c1.059,0,1.916-.549,1.916-1.226V28.776c0-.677-.857-1.226-1.916-1.226h0C263.607,27.55,262.75,28.1,262.75,28.776Z",
    transform: "translate(-176.841 -18.544)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94672",
    "data-name": "Path 94672",
    d: "M318.77,28.776V41.318c0,.677.857,1.226,1.916,1.226h0c1.059,0,1.916-.549,1.916-1.226V28.776c0-.677-.857-1.226-1.916-1.226h0C319.627,27.55,318.77,28.1,318.77,28.776Z",
    transform: "translate(-214.545 -18.544)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94673",
    "data-name": "Path 94673",
    d: "M374.79,28.776V41.318c0,.677.857,1.226,1.916,1.226h0c1.056,0,1.916-.549,1.916-1.226V28.776c0-.677-.86-1.226-1.916-1.226h0C375.647,27.55,374.79,28.1,374.79,28.776Z",
    transform: "translate(-252.249 -18.544)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94674",
    "data-name": "Path 94674",
    d: "M430.8,28.776V41.318c0,.677.86,1.226,1.919,1.226h0c1.056,0,1.916-.549,1.916-1.226V28.776c0-.677-.86-1.226-1.916-1.226h0C431.66,27.55,430.8,28.1,430.8,28.776Z",
    transform: "translate(-289.946 -18.544)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94675",
    "data-name": "Path 94675",
    d: "M486.82,28.776V41.318c0,.677.86,1.226,1.916,1.226h0c1.059,0,1.919-.549,1.919-1.226V28.776c0-.677-.86-1.226-1.919-1.226h0C487.68,27.55,486.82,28.1,486.82,28.776Z",
    transform: "translate(-327.65 -18.544)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94676",
    "data-name": "Path 94676",
    d: "M541.64,28.776V41.318c0,.677.86,1.226,1.916,1.226h0c1.059,0,1.916-.549,1.916-1.226V28.776c0-.677-.857-1.226-1.916-1.226h0C542.5,27.55,541.64,28.1,541.64,28.776Z",
    transform: "translate(-364.546 -18.544)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24277",
    "data-name": "Rectangle 24277",
    width: 3.047,
    height: 172.95,
    transform: "translate(191.14 16.503)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94677",
    "data-name": "Path 94677",
    d: "M430.672,126.467a1.841,1.841,0,1,1-1.838-1.837A1.841,1.841,0,0,1,430.672,126.467Z",
    transform: "translate(-287.382 -83.883)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94678",
    "data-name": "Path 94678",
    d: "M430.672,200.337a1.841,1.841,0,1,1-1.838-1.837A1.841,1.841,0,0,1,430.672,200.337Z",
    transform: "translate(-287.382 -133.601)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94679",
    "data-name": "Path 94679",
    d: "M444.421,200.337a1.841,1.841,0,1,1-1.837-1.837A1.841,1.841,0,0,1,444.421,200.337Z",
    transform: "translate(-296.636 -133.601)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94680",
    "data-name": "Path 94680",
    d: "M458.251,200.337a1.841,1.841,0,1,1-1.837-1.837A1.841,1.841,0,0,1,458.251,200.337Z",
    transform: "translate(-305.944 -133.601)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94681",
    "data-name": "Path 94681",
    d: "M430.671,349.111a1.838,1.838,0,1,1-.537-1.3A1.841,1.841,0,0,1,430.671,349.111Z",
    transform: "translate(-287.382 -233.73)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1261",
    "data-name": "Ellipse 1261",
    cx: 1.837,
    cy: 1.837,
    r: 1.837,
    transform: "translate(66.739 113.544)",
    fill: "#ff2235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94682",
    "data-name": "Path 94682",
    d: "M444.422,349.111a1.838,1.838,0,1,1-.537-1.3A1.841,1.841,0,0,1,444.422,349.111Z",
    transform: "translate(-296.636 -233.73)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94683",
    "data-name": "Path 94683",
    d: "M458.251,349.111a1.837,1.837,0,1,1-.537-1.3A1.841,1.841,0,0,1,458.251,349.111Z",
    transform: "translate(-305.944 -233.73)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94684",
    "data-name": "Path 94684",
    d: "M651.974,181.386c-.513,2.1.173,5.009-.8,6.935-1.635,3.237-6.415,5.385-7.121,8.939-.042.206-5.362,2.769-8.105,1.893-1.435-.454-2.165-1.854-1.059-5.019.347-.981,2.289-1.347,2.812-2.259l-.108-.082c-2.655-2-2.943-6.251-2.393-9.086a30.621,30.621,0,0,1,3.158-8.148,6.233,6.233,0,0,1,5.637-3.041c2.828.049,5.813,1.18,7.285,3.6A8.336,8.336,0,0,1,651.974,181.386Z",
    transform: "translate(-426.946 -115.44)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94685",
    "data-name": "Path 94685",
    d: "M638.165,152.884c-1.448.765-2.988,1.667-4.61,1.422a2.194,2.194,0,0,0,.922,2.027l-1.007.226a.275.275,0,0,0-.209.118.268.268,0,0,0,.023.222,3.316,3.316,0,0,0,1.174,1.429c-.18.386-.83.3-1.053.654a.788.788,0,0,0,0,.67,3.629,3.629,0,0,0,1.112,1.56,1.414,1.414,0,0,0,.6,2.161,1.74,1.74,0,0,0,2.112-1.108,1.746,1.746,0,0,1-.248,1.082c2.743.432,5.676.837,8.2-.327a2.149,2.149,0,0,0-.19.83,3.95,3.95,0,0,0,1.883.118,10.911,10.911,0,0,1-.356,4.009c-.226.811-.549,1.6-.693,2.423a3.289,3.289,0,0,0,.415,2.429,1.235,1.235,0,0,0,.909-.85,4.379,4.379,0,0,1,.539-1.184,1.662,1.662,0,0,1,2.541.363,2.815,2.815,0,0,1-.177,2.838,4.313,4.313,0,0,1-2.825,1.962c.095.912.193,1.824.288,2.733,1.723-1.635,3.652-3.037,5.2-4.826a9.018,9.018,0,0,0,2.524-6.438c-.121-1.455-.755-2.838-.8-4.3-.023-.654.075-1.324.049-1.985a5.382,5.382,0,0,0-3.547-4.751,10.714,10.714,0,0,1-2.491-.847c-.919-.6-1.4-1.7-2.308-2.312a13.649,13.649,0,0,0-3.646-1.246A6.09,6.09,0,0,0,638.165,152.884Z",
    transform: "translate(-426.202 -102.208)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94686",
    "data-name": "Path 94686",
    d: "M584.451,247.223a.98.98,0,0,0-.451.654.654.654,0,0,0,.526.582,1.926,1.926,0,0,0,.84-.039l1.661-.327a5.676,5.676,0,0,0-2.155,2.125.615.615,0,0,0,.029.67c.223.281.6.17.9.052l1.442-.575-.981.951a4.45,4.45,0,0,0-.791.929,1.927,1.927,0,0,0-.209.52.454.454,0,0,0,.572.536,4.4,4.4,0,0,0,1.635-.863,11.121,11.121,0,0,1-1.18,1.4,2.347,2.347,0,0,0-.68,1.635.327.327,0,0,0,.062.183.3.3,0,0,0,.18.085,1.87,1.87,0,0,0,1.419-.654l1.481-1.344a3.313,3.313,0,0,0,.625-.677.932.932,0,0,0,.16-.494.654.654,0,0,0-1-.494c.042-.284.153-.549.222-.827a1.171,1.171,0,0,0-.052-.83.566.566,0,0,0-.719-.271,3.164,3.164,0,0,0,.327-1.089,1.05,1.05,0,0,0-.481-.981.746.746,0,0,1-.242-.154c-.131-.16-.026-.389.03-.589a.952.952,0,0,0-.981-1.272A4.276,4.276,0,0,0,584.451,247.223Z",
    transform: "translate(-393.057 -165.61)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94687",
    "data-name": "Path 94687",
    d: "M617.954,284.074c3.76-3.322,8.416-.8,6.781,3.94-3.534,10.263-10.934,33.778-17.96,33.778-9.155,0-12.856-16.233-12.856-16.233L598.148,297s5.98,13.121,8.991,9.57,4.79-17,10.642-22.344Z",
    transform: "translate(-399.733 -190.177)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94688",
    "data-name": "Path 94688",
    d: "M594.366,301.006a20.393,20.393,0,0,1-.039-2.289,17.247,17.247,0,0,0-2.831-9.367,1.354,1.354,0,0,0-.232.948l.049,8.684a10.066,10.066,0,0,1-.144,2.151c-.111.517-.3,1.01-.448,1.52a8.944,8.944,0,0,0-.327,3.27,3.973,3.973,0,0,0,.468,1.69,1.883,1.883,0,0,0,1.412.955c.193,0,.981-1.635,1.1-1.857q.523-.981.981-1.978c.226-.5.706-1.246.621-1.811C594.876,302.288,594.444,301.7,594.366,301.006Z",
    transform: "translate(-397.338 -194.747)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94689",
    "data-name": "Path 94689",
    d: "M641.446,235.842c-.791.889-1.576,1.782-2.367,2.674a9.378,9.378,0,0,1-2.132,1.962,4.305,4.305,0,0,1-1,.432c-1.435-.454-2.165-1.854-1.059-5.019.347-.981,2.289-1.347,2.812-2.259l-.108-.082a4.944,4.944,0,0,0,1.18.386c.85.127,2.943-.533,3.2.726A1.441,1.441,0,0,1,641.446,235.842Z",
    transform: "translate(-426.946 -157.191)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94690",
    "data-name": "Path 94690",
    d: "M364.984,435.758l3.3,5.12a1.023,1.023,0,0,0,1.635.115l9.076-10.463a1.02,1.02,0,0,0-.768-1.69h-.075a1.023,1.023,0,0,0-.785.366l-7.1,8.514a1.017,1.017,0,0,1-1.635-.095l-1.932-2.943a1.02,1.02,0,0,0-1.007-.448h0a1.017,1.017,0,0,0-.7,1.524Z",
    transform: "translate(-245.553 -288.63)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94691",
    "data-name": "Path 94691",
    d: "M225.387,513.919,229.536,518a1.033,1.033,0,0,1-.726,1.769h-.177a1.043,1.043,0,0,1-.732-.3l-4.038-4.041a1.036,1.036,0,0,0-1.461,0l-4.038,4.041a1.033,1.033,0,0,1-.729.3h-.18a1.033,1.033,0,0,1-.726-1.769l4.152-4.084a1.03,1.03,0,0,0,0-1.465l-4.192-4.192a1.033,1.033,0,0,1,.729-1.762h0a1.027,1.027,0,0,1,.723.294l4.25,4.192a1.033,1.033,0,0,0,1.448,0l4.25-4.192a1.027,1.027,0,0,1,.723-.294h0a1.033,1.033,0,0,1,.732,1.762l-4.192,4.192a1.03,1.03,0,0,0,.033,1.465Z",
    transform: "translate(-145.638 -340.899)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94692",
    "data-name": "Path 94692",
    d: "M130.74,489.92h1.014l.507,22.907-.507-3.773H130.74Z",
    transform: "translate(-87.993 -329.739)",
    fill: "#9f95df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24278",
    "data-name": "Rectangle 24278",
    width: 1.014,
    height: 19.133,
    transform: "translate(43.761 160.181)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94693",
    "data-name": "Path 94693",
    d: "M131.64,520.81",
    transform: "translate(-88.598 -350.53)",
    fill: "#607c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94694",
    "data-name": "Path 94694",
    d: "M108.408,497.971c-.572,1.769,1.236,5.271,2.988,7.082s2.943,1.4,4.728.88c.572-1.769,1.059-2.975-.7-4.787S110.193,497.455,108.408,497.971Z",
    transform: "translate(-72.89 -335.1)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94695",
    "data-name": "Path 94695",
    d: "M142.241,498.2c-1.769-.575-5.271,1.236-7.082,2.988s-1.4,2.943-.879,4.728c1.769.572,2.975,1.059,4.787-.7S142.761,499.981,142.241,498.2Z",
    transform: "translate(-90.077 -335.236)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94696",
    "data-name": "Path 94696",
    d: "M124.525,475.79H120c0,3.214,2.024,5.82,4.522,5.82l1.066-2.854Z",
    transform: "translate(-80.764 -320.229)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94697",
    "data-name": "Path 94697",
    d: "M133.84,475.79h4.522c0,3.214-2.024,5.82-4.522,5.82Z",
    transform: "translate(-90.079 -320.229)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94698",
    "data-name": "Path 94698",
    d: "M107.418,455.561c-.572,1.769,1.236,5.274,2.992,7.082s2.943,1.4,4.725.88c.572-1.769,1.059-2.975-.7-4.787S109.2,455.045,107.418,455.561Z",
    transform: "translate(-72.223 -306.556)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94699",
    "data-name": "Path 94699",
    d: "M141.259,455.778c-1.772-.572-5.274,1.236-7.082,2.992s-1.4,2.943-.883,4.725c1.769.572,2.979,1.059,4.787-.7S141.776,457.566,141.259,455.778Z",
    transform: "translate(-89.416 -306.688)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94700",
    "data-name": "Path 94700",
    d: "M127.305,438.73c-1.674.811-2.943,4.538-3.047,7.059s1.2,5.486,2.805,6.418c1.674-.811,2.71-3.688,2.805-6.212S128.914,439.662,127.305,438.73Z",
    transform: "translate(-83.626 -295.286)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94701",
    "data-name": "Path 94701",
    d: "M106.49,538.77l1.6,12.9h7.379l3.015-7.337-3.015-5.918Z",
    transform: "translate(-71.671 -362.375)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94702",
    "data-name": "Path 94702",
    d: "M142.918,538.77l-1.6,12.9H133.94V538.41Z",
    transform: "translate(-90.146 -362.375)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94703",
    "data-name": "Path 94703",
    d: "M114.413,531.425l-.082.039-2.5,1.242-.683.347h-9.969a1.134,1.134,0,0,1-1.135-1.134v-2.884a1.134,1.134,0,0,1,1.135-1.134h9.969Z",
    transform: "translate(-67.33 -355.302)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94704",
    "data-name": "Path 94704",
    d: "M1.135,0h9.953V5.153H1.135A1.135,1.135,0,0,1,0,4.018V1.135A1.135,1.135,0,0,1,1.135,0Z",
    transform: "translate(54.881 177.751) rotate(180)",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94705",
    "data-name": "Path 94705",
    d: "M108.408,497.971c-.572,1.769,1.236,5.271,2.988,7.082s2.943,1.4,4.728.88c.572-1.769,1.059-2.975-.7-4.787S110.193,497.455,108.408,497.971Z",
    transform: "translate(-72.89 -335.1)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94706",
    "data-name": "Path 94706",
    d: "M142.241,498.2c-1.769-.575-5.271,1.236-7.082,2.988s-1.4,2.943-.879,4.728c1.769.572,2.975,1.059,4.787-.7S142.761,499.981,142.241,498.2Z",
    transform: "translate(-90.077 -335.236)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94707",
    "data-name": "Path 94707",
    d: "M138.3,478.468c-.35,2.763-2.214,4.872-4.46,4.872v-4.98c.036.134.078.268.118.409C135.576,479.292,136.727,479.746,138.3,478.468Z",
    transform: "translate(-90.079 -321.959)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94708",
    "data-name": "Path 94708",
    d: "M107.418,455.561c-.572,1.769,1.236,5.274,2.992,7.082s2.943,1.4,4.725.88c.572-1.769,1.059-2.975-.7-4.787S109.2,455.045,107.418,455.561Z",
    transform: "translate(-72.223 -306.556)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48342",
    "data-name": "Group 48342",
    transform: "translate(34.985 172.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94709",
    "data-name": "Path 94709",
    d: "M115.811,543.66V555.2h-7.383L107,543.66Z",
    transform: "translate(-107 -538.638)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94710",
    "data-name": "Path 94710",
    d: "M142.758,543.66,141.329,555.2H133.95V543.66Z",
    transform: "translate(-125.139 -538.638)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94711",
    "data-name": "Path 94711",
    d: "M145.067,529.434v2.884a1.135,1.135,0,0,1-1.135,1.135H134V528.3h9.949A1.135,1.135,0,0,1,145.067,529.434Z",
    transform: "translate(-125.172 -528.3)",
    fill: "url(#linear-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_94712",
    "data-name": "Path 94712",
    d: "M73.271,578.98l-18.754,3.6a1.151,1.151,0,1,0,.239,2.289H266.577a1.148,1.148,0,0,0,.16-2.289l-27.337-3.44h-.157L73.51,578.974A1.191,1.191,0,0,0,73.271,578.98Z",
    transform: "translate(-35.997 -389.674)",
    fill: "#1d2741",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94713",
    "data-name": "Path 94713",
    d: "M138.078,462.808c-.154.147-.3.281-.445.4-1.573,1.278-2.724.824-4.342.3-.039-.141-.082-.275-.118-.409-.451-1.566-.67-2.7,1-4.316,1.808-1.756,5.31-3.564,7.082-2.992C141.772,457.573,139.889,461.055,138.078,462.808Z",
    transform: "translate(-89.412 -306.695)",
    fill: "url(#linear-gradient-24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddClassPopupPics);
export default __webpack_public_path__ + "static/media/AddClassPopupPics.ff0538350a1dd4808b510fcd4933e922.svg";
export { ForwardRef as ReactComponent };